import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import React, { FC } from 'react';
import { RowItem } from '../../../stores/TimetableVersion/PinboardStoreTypes';
import { GridDay } from '../GridDay/GridDay';
import { GridRowName } from '../GridRowName/GridRowName';
import styles from './../TimetableGrid.module.scss';
import { useTimetableStore } from '../TimetableProvider';
import { HiddenGridRow } from './HiddenGridRow';

type TimetableGridRowProps = {
  row: RowItem;
  daysWidth: string;
  cellWidth: string;
};

export const TimetableGridRow: FC<TimetableGridRowProps> = observer(({ row, daysWidth, cellWidth }) => {
  const pinboardStore = useTimetableStore();

  if (pinboardStore.hiddenRows.has(row.value)) {
    return <HiddenGridRow row={row} />;
  }

  const isFullscreen = pinboardStore.isFullscreen;
  const days = pinboardStore.days;
  const hours = pinboardStore.hours;
  const classes = classNames(styles['grid-row'], {
    [styles['is-fullscreen']]: isFullscreen,
  });

  const rowHeight = pinboardStore.rowHeight;

  return (
    <div className={classes} style={{ height: rowHeight }} data-row-uuid={row.value}>
      <GridRowName row={row} />
      {days.map((day, index) => {
        return (
          <GridDay
            key={`${row.value}-${day.value}`}
            daysWidth={daysWidth}
            hours={hours}
            day={day}
            dayIndex={index}
            row={row}
            cellWidth={cellWidth}
          />
        );
      })}
    </div>
  );
});
